<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
const props = defineProps({
  caption: { type: String, default: "" },
  messages: { type: Array, default: () => [] },
  size: { type: String, default: "small" }
});

let idTimer = 0;
let currentMsgIndex = ref(0);
onMounted(() => {
  idTimer = setInterval(() => {
    currentMsgIndex.value = (currentMsgIndex.value + 1) % props.messages.length;
  }, 5000);
});
onBeforeUnmount(() => {
  clearInterval(idTimer);
});
</script>

<template lang="pug">
.LoadingIcon(class="text-neutral-400 text-xs text-center w-full")
  div(
    class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"
    :class="{ 'h-3 w-3': size == 'small' }"
  )
  p(
    v-if="caption") {{ caption }}
  div(
    v-else-if="props.messages.length"
    class="relative mt-8 h-6"
    )
    Transition(
      enter-active-class="animate-in fade-in duration-500"
      leave-active-class="animate-out fade-out duration-500"
      mode="out-in"
      )
      div(
        :key="currentMsgIndex"
        class="text-center absolute inset-0"
        ) {{ props.messages[currentMsgIndex] }}
</template>
